import React from "react";
//Do not alter except you are sure

//import all components used in the store
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";


//Topbar logo
import logo from "../images/images/smiles_and_laughters_logo2.png";
import { APP_NAME } from "../constants";
import EmailIllustrationSrc from "../images/images/woman-smiling-and-eating-outside-the-pop-porium-shop-2434048.jpg";
import WomanHoldingTomatoes from "../images/images/woman-holding-tomatoes-3213283.jpg";
import { getCategory, getMarket, getPlaceholderPost } from "store/store2";

import SupportIconImage from "../images/support-icon.svg";
import ShieldIconImage from "../images/shield-icon.svg";
import CustomizeIconImage from "../images/customize-icon.svg";
import FastIconImage from "../images/fast-icon.svg";
import ReliableIconImage from "../images/reliable-icon.svg";
import SimpleIconImage from "../images/simple-icon.svg";
import defaultCardImage from "../images/shield-icon.svg";

//DownloadAppData
import mockupImageSrc from "images/app-mockup2.png"
import appleIconImageSrc from "images/apple-icon.png";
import googlePlayIconImageSrc from "images/google-play-icon.png"

//AboutUsData
import CustomerLoveIconImage from "images/simple-icon.svg";

//teamcardgrid(aboutusdata)
import { ReactComponent as LinkedinIcon} from "images/linkedin-icon.svg";
import { ReactComponent as GithubIcon } from "images/github-icon.svg";

const FullStore = {  
    //MAIN PAGE INITAL DATA (AgencyLandingPage)!!!
    
    //Navbar Data. 
    NavBarData: {
        collapseBreakpointClass: "lg",  
        roundedHeaderButton: false,      
        defaultLinks: [{
            linkText: "Home",
            href: "/"            
        },
        {
            linkText: "About",
            href: "/aboutus"            
        },
        {
            linkText: "Co-Op Hub",
            href: "/co-buy"            
        },
        {
            linkText: "Partner",
            href: "/partner"            
        },
        {
            linkText: "Log in",
            href: "/login",            
        },
        {
            linkText: "Sign Up",
            href: "/signup"            
        }],
        PrimaryLinkData: {
            linkText: "Market Partner",
            href: "/signup"            
        },
        defaultLogoLink: {
            linkText: APP_NAME,
            href: "/",
            logo: logo   
        }
    },
    BackgroundAsImageData: {
        BackgroundImage: WomanHoldingTomatoes,        
        Notification: "We have now launched operations in Akure!!",
        Heading: "All Your FoodStuffs",
        SlantedBackground: "IN ONE PLACE!!!",
        Notification2: "#Buy More #Pay less #Save More #Keep Your Schedule #Keep Your Identity and #Stay safe",
        
        //buttons action and text:
        PrimaryActionUrl: "#bf",
        PrimaryActionButtonText: "CLICK HERE TO BUY A FOOD ITEM",
        PrimaryActionUrl2: "/signup",
        PrimaryActionButtonText2: "Become a Market Partner",
    },
    TabCardGridData: {
        //Send all these online and sync with page    
        status: "offline",
        activeTab: "Foods",
        heading: "From Our Stocks",        
        tabs: {
            Foods: [
                {
                    id: 1,
                    imageSrc:
                    require("../images/images/stock-photo-uncooked-rice-in-a-bowl-on-a-white-background-128613017.jpg"),
                    title: "Rice",
                    queryBy: 'Rice',
                    content: "Flakes, Grains, Cereals and Legumes",
                    price: "400",
                    rating: "5.0",
                    reviews: "87",
                    url: "#",
                    type: [
                        {
                            title: 'foreign_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        {
                            title: 'local_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        
                    ]                 
                },
                {
                    id: 2,
                    imageSrc:
                    require("../images/images/RAB2W0.jpg"),
                    title: "Beans",
                    queryBy: 'Beans',
                    content: "Flakes, Grains, Cereals and Legumes",
                    price: "200",
                    rating: "4.8",
                    reviews: "32",
                    url: "#",
                    type: [
                        {
                            title: 'foreign_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        {
                            title: 'local_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        
                    ]   
                },
                {
                    id: 3,
                    imageSrc:
                    require("../images/images/31Mphwims8L.jpg"),
                    title: "Yam",
                    queryBy: 'Yam',
                    content: "Tubers",
                    price: "200",
                    rating: "4.9",
                    reviews: "89",
                    url: "#",
                    type: [
                        {
                            title: 'foreign_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        {
                            title: 'local_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        
                    ]   
                },
                {
                    id: 4,
                    imageSrc:
                    require("../images/images/garri-2.jpg"),
                    title: "Garri",
                    queryBy: 'Garri',
                    content: "Flakes, Grains, Cereals and Legumes",
                    price: "200",
                    rating: "4.6",
                    reviews: "12",
                    url: "#",
                    type: [
                        {
                            title: 'foreign_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        {
                            title: 'local_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        
                    ]   
                },
                {
                    id: 5,
                    imageSrc:
                    require("../images/images/fresh-tomatoes.jpg"),
                    title: "Tomatoes",
                    queryBy: 'Tomatoes',
                    content: "Pepper, Vegetables and Fruits",
                    price: "100",
                    rating: "4.2",
                    reviews: "19",
                    url: "#",
                    type: [
                        {
                            title: 'foreign_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        {
                            title: 'local_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        
                    ]   
                },
                {
                    id: 6,
                    imageSrc:
                    require("../images/images/spinach_620x350_81477995047.jpg"),
                    title: "Spinach",
                    queryBy: 'Spinach',
                    content: "Pepper, Vegetables and Fruits",
                    price: "100",
                    rating: "5.0",
                    reviews: "61",
                    url: "#",
                    type: [
                        {
                            title: 'foreign_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        {
                            title: 'local_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        
                    ]   
                },
                {
                    id: 7,
                    imageSrc:
                    require("../images/images/Study-identifies-quick-and-simple-test-for-salt-levels-in-food_wrbm_large.jpg"),
                    title: "Salt",
                    queryBy: 'Salt',
                    content: "Spices and Sweeteners",
                    price: "100",
                    rating: "4.2",
                    reviews: "95",
                    url: "#",
                    type: [
                        {
                            title: 'foreign_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        {
                            title: 'local_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        
                    ]   
                },
                {
                    id: 8,
                    imageSrc:
                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                    title: "Vegetable Oil",
                    queryBy: 'Vegetable_Oil',
                    content: "Cooking Oil",
                    price: "100",
                    rating: "3.9",
                    reviews: "26",
                    url: "#",
                    type: [
                        {
                            title: 'foreign_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        {
                            title: 'local_rice',
                            imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                            Measure_and_price: [
                                {
                                    measure: 'Cup',
                                    price: 10,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Derica',
                                    price: 20,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Kongo',
                                    price: 30,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Small_Paint_Bucket',
                                    price: 40,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Big_Paint_Bucket',
                                    price: 50,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_50_Kg',
                                    price: 60,
                                    imageSrc:
                                    require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                                {
                                    measure: 'Sack_60_Kg',
                                    price: 700,
                                    imageSrc:
                                        require("../images/images/cooking-oil-being-poured-into-a-bowl.jpg"),
                                },
                            ],
                                
                        },
                        
                    ] 
                }                
            ].sort(() => Math.random() - 0.5),
            Category: getCategory(),
            Market: getMarket()
        }
    },
    BuyFormData: {
        subheading: "BUY A FRESH FOOD ITEM",
        heading: <>Choose an item <span tw="text-green-500">to buy</span><wbr/> from us.</>,
        description: "All fields are required.",
        submitButtonText: "Buy Now",
        formAction: "#",
        formMethod: "post",
        // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
        textOnLeft: true,
        EmailIllustrationSrc,
        formInputData: [
            {
                type: "email",
                name: "email",
                placeholder: "Your Email Address"
            },
            {
                type: "text",
                name: "name",
                placeholder: "Full Name"
            },
            {
                type: "text",
                name: "phone",
                placeholder: "Phone Number"
            },
            {
                type: "text",
                name: "address",
                placeholder: "Collection Address"
            }            
        ],
        formSelectCategoryData: {
            Spices: {
              name: "Spices and Sweeteners",
              value: "Spices_and_Sweeteners",
              items: ['Salt', 'Maggi', 'Thyme']
            },
            Vegetables: {
              name: "Pepper, Vegetables and Fruits",
              value: "Pepper_Vegetables_and_Fruits",
              items: ['Spinach', 'Ugwu', 'Green']
            },
            Tubers: {
              name: "Tubers",
              value: "Tubers",
              items: ['Yam', 'Cocoayam', 'Potato']
            },
            Cereals_Legumes_and_Grains: {
              name: "Flakes, Grains, Cereals and Legumes",
              value: "Flakes_Grains_Cereals_and_Legumes",
              items: ['Rice', 'Beans', 'Cassava']
            },
            Cooking_Oil: {
                name: "Cooking Oil",
                value: "Cooking_Oil",
                items: ['Vegetable Oil', 'Groundnut Oil', 'Castor Oil']
            },
            Sea_and_Frozen_Foods: {
                name: "Sea and Frozen Foods",
                value: "Sea_and_Frozen_Foods",
                items: ['Catfish', 'Fresh Meat(Beaf)', 'Turkey']
            }
        }
    },
    OurBenefitsData: {                
        heading: "Our Amazing Features",
        subheading: "Our Services and Benefits ",
        description: "Don't just eat anything. Eat the best natural foods with just a fraction!",
        defaultCardImage,
        defaultCards: [
            {
              imageSrc: ShieldIconImage,
              title: "Digital Exhibitions",
              description: "Quality Fresh Food Items Captured Directly From The Right Sources."
            },
            { 
              imageSrc: SupportIconImage, title: "Customer Reviews",
              description: "Are products naturally processed to standard? Participate in decision making."
            },
            { 
              imageSrc: CustomizeIconImage, title: "Price Regulation",
              description: "Transparent price fixation process; Accessible, scaled-down, one-for-all delivery."
             },
            { 
              imageSrc: ReliableIconImage, title: "Taskforce and Advocacy",
              description: "We enforce competence, passion and professionalism."
             },
            { 
              imageSrc: FastIconImage, title: "Familiar Measurements and Packs",
              description: "Standard measurements as grammes and kilogrammes, in sacks and poly bags, tin cups, congo bowls, etc.."
             },
            { 
              imageSrc: SimpleIconImage, title: "lots more",
              description: "Money-back guarantee, Food Endorsement, Reliability, Secure, Fast..."
           }
        ]          
    },
    TestimonialsData: {        
        subheading: "Testimonials",
        heading: 
            <>
            Our Clients <span tw="text-primary-500">Love Us.</span>
            </>,
      
        description: "Here are what some of our amazing customers are saying about us.",
        testimonials: [
            {
            imageSrc:
                require("../images/images/gettyimages-612009118-612x612.jpg"),
            profileImageSrc:
                require("../images/images/black-woman-5505581_960_720.jpg"),
            quote:
                "Their goods are so fresh. Their delivery is awesome. They are so organised and my engagement with them is so smooth and attractive.",
            customerName: "Susan O.A.",
            customerTitle: "Owner, Sweit Ventures."
            },
            {
            imageSrc:
                require("../images/images/8cb5d6bca5a6cde3753bc60aa7f7-1568855.jpg"),
            profileImageSrc:
            require("../images/images/people-2564420__340.jpg"),
            quote:
                `${APP_NAME} unexpectedly has the best hands on deck. I strongly recommend them. Trying them will convince you, definitely.`,
            customerName: "Ruth Olagunju",
            customerTitle: "Patron"
            }
        ],        
        textOnLeft:true
    },
    WelcomeRemarkData: {
        heading: "Participate. Raise the Standard.",
        description: "By purchasing from us, we help you leverage the strengths and opportunities of the local food market. By supporting us, we help you attain more purchasing power to tend to the numerous other needs while you save more on quality local foods...",
        imageSrc: require("../images/images/african-american-1436660_1280.jpg"),
        imageDecoratorBlob: true,
        primaryButtonUrl: "https://google.com",
        primaryButtonText: "Get Started",
        buttonRounded: true,
        features: ["Premium Internet Backbone", "99.99% Uptime SLA"],
        testimonial: {
          quote: "I believe that two heads are better than one, so are multiple heads than a few. Join our food quality, availability and affordability movement so we can push off the limit to a greater standard. So, what do you say?",
          customerName: "Emmanuel Adebayo",
          customerCompany: `Founder, ${APP_NAME}. DigiMart.`
        }
    },
    SubscribeData: {
        subheading: "Newsletters",
        heading: <>Subscribe now <span tw="text-green-500">to our newsletters.</span><wbr/> Miss nothing!.</>,
        description: "We deliver high quality market news and food tips written by professionals weekly. And we promise no spam.",
        submitButtonText: "Subscribe",
        formAction: "#",
        formMethod: "get",
        textOnLeft: true,
        remark: null
    },
    DownloadAppData: {
        subheading: "Download Our Mobile App",
        text: "Get ease, speed and better experience.",
        link1Text: "App Store",
        link1Url: "http://apple.com",
        link1IconSrc: appleIconImageSrc,
        link2Text: "Google Play",
        link2Url: "http://play.google.com",
        link2IconSrc: googlePlayIconImageSrc,
        pushDownFooter: false,
        imageSrc: mockupImageSrc
    },
    ContactUsData: {
        heading: 'Contact Us',
        formAction: "#",
        inputs: [
            {
                labelDetails: {
                    htmlFor: "name-input",
                    innerHtml: "Your Name"
                },
                inputDetails: {
                    id: "name-input",
                    type: "text",
                    name: "name",
                    placeholder: "E.g. John Doe"
                }
            },
            {
                labelDetails: {
                    htmlFor: "email-input",
                    innerHtml: "Your Email Address"
                },
                inputDetails: {
                    id: "email-input",
                    type: "email",
                    name: "email",
                    placeholder: "E.g. john@mail.com"
                }
            }            
        ],
        messageInput: {            
            placeholder: "E.g. Details about your event"            
        },
        instruction:
         <>
            Due to our business schedule as stated below, we may not be able to respond to your request until our next working day.
            <br />
            <br />
            <h2>Our Schedule</h2>
            <hr />
            <br />
            <h3>DELIVERY HOURS:</h3>
            Monday – Friday: 9am to 6pm
            <br />
            Saturday : 9am to 3pm                  
            <br />
            <br />
            <h3>VACATIONS:</h3>                                    
            All Sundays
            <br />
            All Official Holidays                                    
            <br />
            <br />
            <h3>FOR EMERGENCY CASES, CALL</h3>
            (+234) 810 169 1795
         </>
},
    BlogData: {
        heading: "Food Tips",
        cards: [],
        sliderSettings: {
            arrows: false,
            slidesToShow: 3,
            responsive: [
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 2,
                }
              },
         
              {
                breakpoint: 900,
                settings: {
                  slidesToShow: 1,
                }
              },
            ]
        }
    },
    FooterData: {
        LogoImage: logo,
        LogoText: APP_NAME,
        CompanyAddressData: `${APP_NAME}, Piwoyi, Abuja.`,
        SocialLink: [
            {
                href: "https://facebook.com",
                Icon: <FacebookIcon />
            },
            {
                href: "https://youtube.com",
                Icon: <YoutubeIcon />
            }
        ],
        ColumnHeading1: "Quick Links",
        ColumnHeading2: "Product Categories",
        ColumnHeading3: "Legal",
        ColumnHeading4: "Contact",
        LinkListItem1: [
            {
                href: "/blog",
                innerHtml:"Blog"
            },
            {
                href: "/aboutus",
                innerHtml:"About Us"
            },
            {
                href: "/co-buy",
                innerHtml:"Co-Op Hub"
            },
            {
                href: "/partner",
                innerHtml:"Become a Partner"
            },
            {
                href: "/login",
                innerHtml:"Log In"
            }
        ],
        LinkListItem2: [
            {
                href: "/marketplace?page=stock&tab=Foods",
                innerHtml:"Flakes, Grains, Cereals and Legumes"
            },
            {
                href: "/marketplace?page=stock&tab=Foods",
                innerHtml:"Tubers"
            },
            {
                href: "/marketplace?page=stock&tab=Foods",
                innerHtml:"Pepper, Vegetables and Fruits"
            },
            {
                href: "/marketplace?page=stock&tab=Foods",
                innerHtml:"Spices"
            },
            {
                href: "/marketplace?page=stock&tab=Foods",
                innerHtml: "Cooking Oil"
            },
            {
                href: "/marketplace?page=stock&tab=Foods",
                innerHtml: "Sea and Frozen Foods"
            }
        ],
        LinkListItem3: [
            {
                href: "/privacy",
                innerHtml:"Privacy Policy"
            },
            {
                href: "/tos",
                innerHtml:"Terms of Service"
            },
        ],
        LinkListItem4: [
            {
                href: "tel:+2348101691795",
                innerHtml:"+234 (810) (169)-1795"
            },
            {
                href: "mailto:giftedcardis@outlook.com",
                innerHtml:"giftedcardis@outlook.com"
            },
        ],
        CopyrightData: `Copyright ${new Date().getFullYear()}, ${APP_NAME}.`,
        CompanyInfoData: "Your local foods made available in style."
    },
    AboutUsData: {
        MainFeatures: {
            buttonRounded: true,
            imageRounded: true,
            imageBorder: false,
            imageShadow: false,
            imageCss: null,
            imageDecoratorBlob: false,
            imageDecoratorBlobCss: null,
            MainFeaturesOtherData: [        
                {
                    subheading:`Welcome To ${APP_NAME}`,
                    heading: (
                        <>
                        We Help You Leverage The <span tw="text-primary-500">Local Food Market.</span>
                        </>
                    ),                
                    description: `${APP_NAME} helps buyers get closer to their local food sellers and farmers with the aim of upholding outstanding purchasing standards. We believe that two heads are better than one, so are multiple heads better than a few. With the says of both the many buyers and sellers, a much greater standards can be achieved. This we try to do through our favorable programs such as our digital exhibitions, taskforce and advocacy, satisfaction level reviews, money-back guarantee, and lots more. Regardless of your class, ${APP_NAME} helps you leverage on the strengths and opportunities of the local food market, thereby giving you more financial purchasing power to tend to the numerous other needs.`,                    
                    primaryButtonText: "See More",
                    primaryButtonUrl: "#",
                    imageSrc: require("../images/images/fresh-sweet-apricots-on-white-table-with-whole-cantaloupe-4397916.jpg"),
                    textOnLeft: false
                },
                {
                    subheading: 'Our Vision',
                    heading: (
                        <>
                        We aim to regenerate the <span tw="text-primary-500">Local Food Market.</span>
                        </>
                    ),                
                    description: `We see ${APP_NAME} Foodstuffs DigiMart optimally organising the overall production and acquisition of local foods in any locality with extreme standards, thereby making sure that all buyers get the best possible satisfaction they desire, and also making sure that sellers and producers go extra miles to gladly and satisfactorily make quality produce available for purchase.`,                
                    primaryButtonText: "Contact Us",
                    imageSrc: require("../images/images/people-around-a-table-with-food-4262172.jpg"),
                    textOnLeft: true                
                }
            ],
        },
        Features: {    
            subheading: 'Our Values',
            heading: "We follow these.",
            description: "(SUPPORT)",
            cards: [
                {
                    imageSrc: SupportIconImage,
                    title: "24/7 Support",
                    description: "Team work, Respect, Importance, Satisfaction, Subjection, Conscience."
                },
                {
                    imageSrc: SupportIconImage,
                    title: "Understand",
                    description: "No ambiguity, No assumption."
                },
                {
                    imageSrc: SupportIconImage,
                    title: "Plan",
                    description: "God-head, Visionary, Rigor, Design, Fore-sight."
                },
                {
                    imageSrc: SupportIconImage,
                    title: "Prepare",
                    description: "Multi-tasking, Supervision, Detailing."
                },
                {
                    imageSrc: SupportIconImage,
                    title: "Organise",
                    description: "Documentation, Consciousness, Taste."
                },
                {
                    imageSrc: ShieldIconImage,
                    title: "Reliable",
                    description: "Trust-worthiness, Less Excuse, "
                },
                {
                    imageSrc: CustomerLoveIconImage,
                    title: "Train",
                    description: "Learning, Skill, Certification, Professionalism, Ranking."
                },
            ],
            linkText: "Learn More",
            imageContainerCss: null,
            imageCss: null
        },
        TeamCardGrid: {
            subheading: 'Our Team',            
            heading: "Meet These Fine Folks.",            
            description: "They make sure you do not just eat anything but the best",
            cards: [
                {
                    imageSrc: require("../images/images/african-american-1436660_1280.jpg"),
                    position: "Team Lead",
                    name: "Emmanuel Adebayo",
                    links: [
                        {
                        url: "#",
                        icon: TwitterIcon,
                        },
                        {
                        url: "#",
                        icon: LinkedinIcon,
                        },
                        {
                        url: "#",
                        icon: GithubIcon,
                        },
                    ]
                },
                {
                    imageSrc: require("../images/images/African-Woman-Business-Woman-Young-Woman-Black-Woman-3439224.jpg"),
                    position: "Admin",
                    name: "Victoria Oluwaseyi.",
                    links: [
                        {
                        url: "#",
                        icon: TwitterIcon,
                        },
                        {
                        url: "#",
                        icon: LinkedinIcon,
                        },
                        {
                        url: "#",
                        icon: GithubIcon,
                        },
                    ]
                },
                {
                    imageSrc: require("../images/images/vlcsnap-2021-06-24-14h05m18s957.png"),
                    position: "Food Processing Manager",
                    name: "Gbenro Johnson.",
                    links: [
                        {
                        url: "#",
                        icon: TwitterIcon,
                        },
                        {
                        url: "#",
                        icon: LinkedinIcon,
                        },
                        {
                        url: "#",
                        icon: GithubIcon,
                        },
                    ]
                },
                {
                    imageSrc: require("../images/images/gettyimages-1266986195-612x612.jpg"),
                    position: "Line Manager",
                    name: "Toheeb Olayiwola",
                    links: [
                        {
                        url: "#",
                        icon: TwitterIcon,
                        },
                        {
                        url: "#",
                        icon: LinkedinIcon,
                        },
                        {
                        url: "#",
                        icon: GithubIcon,
                        },
                    ]
                },
                {
                    imageSrc: require("../images/images/people-2564420__340.jpg"),
                    position: "Brand Face",
                    name: "Ruth Oluwatominsin",
                    links: [
                        {
                        url: "#",
                        icon: TwitterIcon,
                        },
                        {
                        url: "#",
                        icon: LinkedinIcon,
                        },
                        {
                        url: "#",
                        icon: GithubIcon,
                        }
                    ]
                },    
            ]              
        }
    },
    InBlogMarketDisplayData: {
        Markets: {            
            iFoods: getPlaceholderPost(),
            Adept_Sea_Foods: getPlaceholderPost(),
            Mama_Bola_Tuber_Stores: getPlaceholderPost(),
            AB_Seafood_Ventures: getPlaceholderPost(),
            Seyi_Spices: getPlaceholderPost(),
            Fine_Five_Pepper: getPlaceholderPost(),
            Susan_Pastries: getPlaceholderPost(),
            Sweit_Cakes_and_Pastries: getPlaceholderPost(),
            Laide_Grain_Stores: getPlaceholderPost(),               
        },
        Foods: {
            Rice: getPlaceholderPost(),
            Beans: getPlaceholderPost(),
            Garri: getPlaceholderPost(),
            Wheat: getPlaceholderPost(),
            Soy: getPlaceholderPost(),
            Cassava: getPlaceholderPost(),
            Flour: getPlaceholderPost(),
            Yam_Flour: getPlaceholderPost(),
            Yam: getPlaceholderPost(),
            Potatoes: getPlaceholderPost(),
            Water_Yam: getPlaceholderPost(),
            Tomatoes: getPlaceholderPost(),
            Spinach: getPlaceholderPost(),
            Rodo: getPlaceholderPost(),
            Tatashe: getPlaceholderPost(),
            Bawa: getPlaceholderPost(),
            Ugwu: getPlaceholderPost(),
            Green: getPlaceholderPost(),
            Apple: getPlaceholderPost(),
            Pineapple: getPlaceholderPost(),
            Banana: getPlaceholderPost(),
            Oranges: getPlaceholderPost(),
            Vegetable_Oil: getPlaceholderPost(),
            Groundnut_Oil: getPlaceholderPost(),
            Catfish: getPlaceholderPost(),
            Fresh_Meat: getPlaceholderPost(),
            Pomo: getPlaceholderPost(),
            Turkey: getPlaceholderPost(),
            Chicken: getPlaceholderPost(),
            Titus: getPlaceholderPost(),
            Sawa: getPlaceholderPost(),
            Bread: getPlaceholderPost(),
            Fish_Pie: getPlaceholderPost(),
            Meat_pie: getPlaceholderPost(),
            Sausage: getPlaceholderPost(),
            Doughnut: getPlaceholderPost(),
            Ice_Cream: getPlaceholderPost(),
            Scotch_Egg: getPlaceholderPost(),
            Groundnut: getPlaceholderPost(),
            Honey: getPlaceholderPost(),
            Kuli: getPlaceholderPost(),
            Sugar: getPlaceholderPost(),
            Salt: getPlaceholderPost(),
            Curry: getPlaceholderPost(),
            Thyme: getPlaceholderPost(),
            Ginger: getPlaceholderPost()
        },
        Category: {
            Flakes_Grains_Cereals_and_Legumes: {
                category: 'Flakes, Grains, Cereals and Legumes',
                foods: ['Rice', 'Beans', 'Garri', 'Wheat', 'Soy', 'Flour', 'Yam Flour'],        
                markets: getPlaceholderPost(),
            },
            Tubers: {
                category: 'Tubers',
                foods: ['Yam', 'Cassava', 'Potatoes', 'Water Yam'],
                markets: getPlaceholderPost(),
            },
            Pepper_Vegetables_and_Fruits: {
                category: 'Pepper, Vegetables and Fruits',
                foods: ['Tomatoes', 'Spinach', 'Rodo(Scotch Boonet)', 'Tatashe(Bell Pepper)',
                'Bawa', 'Ugwu', 'Green', 'apple', 'Pineapple', 'Banana', 'Oranges'],
                markets: getPlaceholderPost(),
            },
            Cooking_Oil: {
                category: 'Cooking Oil',
                foods: ['Vegetable Oil', 'Groundnut Oil'],
                markets: getPlaceholderPost(),
            },
            Sea_and_Frozen_Foods: {
                category: 'Sea and Frozen Foods',
                foods: ['Catfish', 'Fresh Meat(Beaf)', 'Pomo(Cow/Goat\'s)', 'Turkey', 'Chicken', 
                'Titus Fish', 'Sawa(Tilapia)'],
                markets: getPlaceholderPost(),
            },
            Cakes_and_Pastries: {
                category: 'Cakes and Pastries',
                foods: ['Bread', 'Fish Pie', 'Meat Pie', 'Sausage', 'Doughnut', 'Ice Cream', 
                'Scotch Egg'],
                markets: getPlaceholderPost()
            },
            Miscs: {
                category: 'Miscs',
                foods: ['Goundnut', 'Honey', 'Kuli'],
                markets: getPlaceholderPost()
            }, 
            Spices_and_Sweeteners: {
                category: 'Spices and Sweeteners',
                foods: ['Sugar', 'Salt', 'Curry', 'Thyme', 'Ginger'],
                markets: getPlaceholderPost()
            }
        },
    },
    Measure_and_price: {        
        Kuli: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Honey: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Goundnut: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Ginger: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Thyme: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Curry: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Salt: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Sugar: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Scotch_Egg: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Ice_Cream: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Doughnut: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Sausage: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Meat_Pie: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Fish_Pie: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Bread: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Yam: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Cassava: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Potatoes: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Water_Yam: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Tomatoes: {     
            OtherName: '',           
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Spinach: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Rodo: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Tatashe: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Bawa: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Ugwu: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Green: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Pineapple: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        
        Catfish: { 
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Fresh_Meat: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Pomo: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Turkey: {
            One_KG: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700,
            Life_Turkey: 1200
        },
        Chicken: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Titus_Fish: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Sawa: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        apple: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Banana: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Oranges: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },               
        Vegetable_Oil: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Groundnut_Oil: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },       
        Rice: { 
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Beans: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Garri: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Wheat: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Soy: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Flour: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        },
        Yam_Flour: {
            Cup: 10,
            Derica: 20,
            Kongo: 30,
            Small_Paint_Bucket: 40,
            Big_Paint_Bucket: 50,
            Sack_50_Kg: 60,
            Sack_60_Kg: 700
        }
    }   
};



export default FullStore;